import { useDexExtractedFieldsQuery } from "#graphql/supergraphHooks";
import type { DexExtractedFieldsQuery } from "#graphql/supergraphTypes";
import type { ApolloError } from "@apollo/client";

export type ExtractedField = DexExtractedFieldsQuery["dexExtractedFields"][number];

export interface UseExtractedFieldsResult {
  fields: ExtractedField[];
  loading: boolean;
  error?: ApolloError;
}

export function useExtractedFields(documentId: string): UseExtractedFieldsResult {
  const { data, loading, error } = useDexExtractedFieldsQuery({
    variables: { documentId },
    fetchPolicy: "cache-and-network",
  });
  return { fields: data?.dexExtractedFields ?? [], loading, error };
}
